import {AddItemResponseStatus_Success_Section_BasketUrgency} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import React from 'react';
import {BasketUrgencyComposedHint} from './BasketUrgencyComposedHint';
import {BasketUrgencyHintWrapper} from './BasketUrgencyHintWrapper';
import {BasketUrgencySimpleHint} from './BasketUrgencySimpleHint';

export const BasketUrgencyHint: React.FC<{
  basketUrgency?: AddItemResponseStatus_Success_Section_BasketUrgency;
}> = ({basketUrgency}) => {
  switch (basketUrgency?.type?.$case) {
    case 'simpleHint':
      return (
        <BasketUrgencySimpleHint simpleHint={basketUrgency.type.simpleHint} />
      );
    case 'composedHint':
      return (
        <BasketUrgencyComposedHint
          composedHint={basketUrgency.type.composedHint}
        />
      );
    case 'noHint':
      return <BasketUrgencyHintWrapper />;
    default:
      return null;
  }
};
